import { useEffect, useCallback } from 'react'
import { useStorageState } from 'react-storage-hooks'

const buildUrl = ({
  state,
  scope,
  clientId: client_id,
  redirectUri: redirect_uri,
  authorizeUrl,
  response_type = 'token'
}) =>
  `${authorizeUrl}?${Object.entries({
    response_type,
    client_id,
    redirect_uri,
    scope,
    state
  })
    .map(([k, v]) => [k, v].map(encodeURIComponent).join('='))
    .join('&')}`

const urlParamsToObject = urlParams =>
  urlParams
    .slice(1)
    .split('&')
    .reduce((acc, param) => {
      const index = param.indexOf('=')
      const key = decodeURIComponent(param.slice(0, index))
      if (key) {
        acc[key] = decodeURIComponent(param.slice(index + 1))
      }
      return acc
    }, {})

const cryptoRandomString = () => {
  const entropy = new Uint32Array(5)
  window.crypto.getRandomValues(entropy)
  return window.btoa([...entropy].join(','))
}

export const storagePrefix = process.env.REACT_APP_STORAGE_PREFIX || 'ia.tic.gov.pt'

export const useOAuth2 = ({ scope, clientId, authorizeUrl, redirectUri }) => {
  const [, setState] = useStorageState(localStorage, `${storagePrefix}-oauth-state`)
  const [token, setToken] = useStorageState(localStorage, `${storagePrefix}-access_token`)

  const clearToken = () => {
    setToken(null)
  }

  const getToken = useCallback(() => {
    const state = cryptoRandomString()
    setState(state)
    console.log('useOAuth2 :: getToken - state:', state)
    setImmediate(() => {
      window.location.href = buildUrl({ state, scope, clientId, redirectUri, authorizeUrl })
    })
  }, [scope, clientId, setState, redirectUri, authorizeUrl])

  return {
    token,
    getToken,
    setToken,
    clearToken
  }
}

export const useOAuthCallback = ({ onSuccess, onError }) => {
  const [, setToken] = useStorageState(localStorage, `${storagePrefix}-access_token`)
  const [state, setState] = useStorageState(localStorage, `${storagePrefix}-oauth-state`)

  const handleError = useCallback(
    error => {
      setState(null)
      onError && onError(error)
    },
    [onError, setState]
  )
  const handleSuccess = useCallback(
    token => {
      setToken(token)
      setState(null)
      console.log('useOAuthCallback :: handleSuccess - token:', token)
      onSuccess && onSuccess()
    },
    [setToken, setState, onSuccess]
  )

  useEffect(() => {
    const params = {
      ...urlParamsToObject(window.location.hash),
      ...urlParamsToObject(window.location.search)
    }

    if (state !== params.state) {
      handleError('Invalid state')
    } else if (!params.access_token) {
      handleError('Token missing')
    } else {
      handleSuccess(params.access_token)
    }
  })

  return {}
}
